import { jsx } from "react/jsx-runtime";
import Icon_module from "./Icon.module.js";
var Icon_IconColor = /*#__PURE__*/ function(IconColor) {
    IconColor["Success"] = "color-success-600";
    IconColor["Primary"] = "color-primary-500";
    IconColor["Alert"] = "color-alert-600";
    IconColor["Danger"] = "color-danger-600";
    return IconColor;
}({});
const gridSize = 24;
const IconContainer = ({ children, color, testId })=>/*#__PURE__*/ jsx("svg", {
        width: "24px",
        height: "24px",
        viewBox: `0 0 ${gridSize} ${gridSize}`,
        className: Icon_module.icon,
        "data-icon-color": color,
        "data-testid": testId,
        children: /*#__PURE__*/ jsx("g", {
            transform: `rotate(0 ${gridSize / 2} ${gridSize / 2})`,
            children: children
        })
    });
export { Icon_IconColor as IconColor, IconContainer };
